// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderMobile_header__n87dN","logoLink":"HeaderMobile_logoLink__oVeGM","spacedGroup":"HeaderMobile_spacedGroup__BnJRF"};